import React from 'react';
import logo from './logo.svg';
import './App.css';
import { AuthProvider } from './Context/AuthProvider';
import { Provider } from 'react-redux';
import AuthRoute from './Route/AuthRoute';
import { store } from './redux/store';
import "@fontsource/poppins";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/400-italic.css";
import './i18n';
import './AxiosInterceptor'
import SwitchLanguage from './switchLanguage/switchLanguage';

function App() {
  return (<>
    {/* @ts-ignore */}
    <AuthProvider>
      {/* <SwitchLanguage /> */}
      <Provider store={store}>
        <AuthRoute />
      </Provider>
    </AuthProvider>
  </>
  );
}

export default App;
